// Extracted from `./content` so callers outside this directory (e.g.
// `pages/home/prelaunch/ResponsiveMasonry`) can pull just the image
// URLs without dragging the full 100+ KB about-stories content module
// into their chunk graph.
export const benefitsImages = [
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/1/medium-cf06bdecf3640eee7dd172b14f3c7fa3.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/1/large-b3a9a3b1ab52f57dc9aba24eb77c7d0e.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/2/medium-ff20387e0eed986fb012738076fbdf0b.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/2/large-9d472838580989850a91be74e412a104.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/3/medium-3e1acd9634be3720010c89da8a4484de.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/3/large-5ffb89993bf09446e205ecca87015a7d.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/4/medium-20ef4487b73ff9015230c9d6b7d0ad8a.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/4/large-522b1a344794cbf0e6f459f225f67b44.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/5/medium-88e1bf03fd2e1b138fa638635d174139.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/5/large-bb9806ad324015d5df11e90862b0e8fd.jpg',
  },
  {
    medium:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/6/medium-6b6329af529753291f0f0a43a0504573.jpg',
    large:
      'https://assets.riparide.com/landing_pages/stories/customer/benefits/6/large-63c99f813ca7a1f7d754846b5d635ff6.jpg',
  },
]
